import { createSelector } from 'reselect'
import { currentUserSelector } from 'selectors/currentUser'
import _ from 'lodash'

export const getShowProfile = (state, props) => {
  return state.kanbo.layout.showProfile
}

export const getUsers = (state, props) => {
  return state.kanbo.users
}

export const profileSelector = createSelector(
  [getShowProfile, getUsers],
  (showProfile, users) => {
    const profileKey = showProfile

    let profile = {
      isLoaded: false
    }
    let id = null
    let name = null
    let licenseType = null
    let isActive = true

    if (profileKey) {
      const ids = Object.keys(users)
      const length = ids.length
      for (let i = 0; i < length; i++) {
        const _user = users[ids[i]]
        if (_user.profileKey === profileKey) {
          profile = _user.profile
          id = _user.id
          name = _user.name
          licenseType = _user.licenseType
          isActive = _user.isActive
          break
        }
      }
    }

    return {
      profileKey,
      id,
      name,
      licenseType,
      profile,
      isActive
    }
  }
)

export const getUserAvatars = (state, props) => {
  return state.kanbo.userAvatars
}

export const isAvatarSetSelector = createSelector(
  [getShowProfile, getUserAvatars],
  (showProfile, userAvatars) => {
    const userAvatar = userAvatars[showProfile]

    if (!userAvatar) return false

    return Boolean(userAvatar.src)
  }
)

export default createSelector(
  [
    profileSelector,
    currentUserSelector,
    isAvatarSetSelector,
  ],
  (
    profile,
    currentUser,
    isAvatarSet,
  ) => ({
    ...profile,
    currentUser,
    isAvatarSet,
  })
)
